"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.u1F424 = void 0;
var u1F424 = {
  "viewBox": "0 0 2600 2760.837",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2290 1544.5q-134 192.5-263 290T1740 1989l34 27q16 13 34 24l25 14q24 14 35.5 30.5t11.5 41.5q0 29-25.5 64.5T1804 2258t-52.5 60.5-55.5 28.5q-25 0-47.5-18.5T1626 2285q0-34 50-82.5t50-82.5q0-21-18.5-44.5T1644 2020q-81 23-163.5 33t-166.5 10q-37 0-74-1t-73-5l-37 76q-29 58-41 136t-85 78q-19 0-105-28t-111-46.5-25-54.5q0-25 14-45.5t44-20.5q28 0 75.5 23t74.5 23q51 0 76-80.5t23-74.5q-325-62-494.5-289T406 1187q-44-15-84.5-33.5T238 1118l-19-7q-16-5-30-14t-14-19q0-13 23-23.5T426 967q19-119 108.5-258.5t224.5-202 327-62.5q83 0 185 26.5t199 80 154.5 129 137 170T1933 1001t170 57q37 0 94.5-14t98.5-14q58 0 93 42t35 110q0 170-134 362.5zm-1519.5-651Q748 866 718 866q-33 0-56.5 27T638 961q0 42 23.5 66.5T718 1052q32 0 53.5-28t21.5-65q0-38-22.5-65.5zM1987 1194q-69-38-225-38-34 0-67-2l-74-6-74-4q-13 0-29.5-2.5t-33.5-2.5q-19 0-32 7t-13 17q0 42 170.5 59.5T1784 1240l50 4q49 4 79.5 23.5t30.5 60.5q0 48-35 132t-140 141-250 57q-91 0-167-21.5t-119-53.5-63-32q-8 0-13 6.5t-5 14.5q0 39 126 107t278 68q141 0 267-66t179.5-165.5T2056 1328q0-96-69-134z"
    },
    "children": []
  }]
};
exports.u1F424 = u1F424;